import { render, staticRenderFns } from "./manage-evalutor.vue?vue&type=template&id=79f5515d&"
import script from "./manage-evalutor.js?vue&type=script&lang=js&"
export * from "./manage-evalutor.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports